import { RSAA } from 'redux-api-middleware';
import fetch from 'isomorphic-fetch';
import api from '../../api';

// ------------------------------------
// Constants
// ------------------------------------
const LOAD_REQUEST = 'farmakom/products/LOAD_REQUEST';
const LOAD_SUCCESS = 'farmakom/products/LOAD_SUCCESS';
const LOAD_FAILURE = 'farmakom/products/LOAD_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------

// API CALL
export function loadProductsByCategory(params, query) {
  const category = params.subcategory || params.category;
  const page = query.page;
  const sort = query.sort;

  return {
    [RSAA]: {
      ...api.getProductsByCategory(category, page, sort),
      types: [LOAD_REQUEST, LOAD_SUCCESS, LOAD_FAILURE],
    },
  };
}

// API CALL
export function loadProductsByKeywords(params, query) {
  return {
    [RSAA]: {
      ...api.getProductsByKeywords(params.keywords, query.page, query.pageSize),
      types: [LOAD_REQUEST, LOAD_SUCCESS, LOAD_FAILURE],
    },
  };
}

// API CALL
export function loadProductsByTag(params, query) {
  return {
    [RSAA]: {
      ...api.getProductsByTag(
        params.tag,
        query.page,
        query.pageSize,
        query.sort
      ),
      types: [LOAD_REQUEST, LOAD_SUCCESS, LOAD_FAILURE],
    },
  };
}

// API CALL
export function loadProductsByBrand(params, query) {
  return {
    [RSAA]: {
      ...api.getProductgetProductsByBrand(
        params.brand,
        query.page,
        query.pageSize,
        query.sort
      ),
      types: [LOAD_REQUEST, LOAD_SUCCESS, LOAD_FAILURE],
    },
  };
}

// API CALL
export function loadProductsBySymptom(params, query) {
  return {
    [RSAA]: {
      ...api.getProductgetProductsBySymptom(
        params.symptom,
        query.page,
        query.pageSize,
        query.sort
      ),
      types: [LOAD_REQUEST, LOAD_SUCCESS, LOAD_FAILURE],
    },
  };
}
// API CALL - i prodotti più venduti
export function loadProductsByCalculatedSales(params, query) {
  return {
    [RSAA]: {
      ...api.getProductsByCalculatedSales(
        query.page,
        query.pageSize,
        query.sort
      ),
      types: [LOAD_REQUEST, LOAD_SUCCESS, LOAD_FAILURE],
    },
  };
}
// API CALL - i farmaci più venduti
export function loadDrugsByCalculatedSales(params, query) {
  return {
    [RSAA]: {
      ...api.getDrugsByCalculatedSales(query.page, query.pageSize, query.sort),
      types: [LOAD_REQUEST, LOAD_SUCCESS, LOAD_FAILURE],
    },
  };
}

// API CALL
export function loadProductsByTagCategory(params, query) {
  return {
    [RSAA]: {
      ...api.getProductsByTagCategory(
        params.tag,
        query.page,
        query.pageSize,
        query.sort
      ),
      types: [LOAD_REQUEST, LOAD_SUCCESS, LOAD_FAILURE],
    },
  };
}

// API CALL
export function loadProductsDiscounted(params, query) {
  return {
    [RSAA]: {
      ...api.getProductsDiscounted(query.page, query.pageSize, query.sort),
      types: [LOAD_REQUEST, LOAD_SUCCESS, LOAD_FAILURE],
    },
  };
}

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  loading: false,
  error: '',
  data: [],
  pagination: {
    page: 1,
    totalPages: 1,
  },
};

export default function productsReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.items,
        pagination: action.payload.pagination,
        error: null,
      };
    case LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    default:
      return state;
  }
}
